/**
 * @file   src\mobile\components\SendIntroduction\AddClient.js
 * @brief  This file is responsible for add client functionality
 * @date   May, 2024
 * @author ZCO Engineer
 * @copyright (c) 2024, ZCO
 */
import { useState } from "react";
import { saveAgentClient } from "../../../services/agentClientsService";
import { toast } from "react-toastify";
import AddPropertyPlus from "../../../images/add-property-plus-icon.svg";

const AddClient = (props) => {
  const [showAddClient, setShowAddClient] = useState(false);
  const handleClose = () => setShowAddClient(false);
  const handleShow = () => setShowAddClient(true);

  /**
   * To add client data
   * @param {*} data 
   */
  const addClientData = async (data) => {
    var param = {
      ...data,
    };
    await saveAgentClient(param)
      .then((response) => {
        if (response.errorCode === 0) {
          const userDetails = getLocalStorage(USER_INFO_KEY);
          const updatedUserDetails = [
            ...userDetails,
            { ClientCount: userDetails?.ClientCount + 1 },
          ];

          setLocalStorage(USER_INFO_KEY, updatedUserDetails);
          if (response.result.agentExist) {
            toast.success(response.message);
          } else {
            toast.success("Added client successfully!");
            handleClose();
          }
        } else {
          return;
        }
      })
      .catch((err) => {
        console.log("Error", err);
      });
  };

  return (
    <a role="button" href={void 0} onClick={() => handleShow()}>
      <div className="my-property-mob pt-12">
        <div className="add-property-smallbtn-mob">
          <img src={AddPropertyPlus} />
        </div>
        <div className="my-property-details-mob">
          <h3 className="mb-0">Add Client</h3>
        </div>
      </div>
    </a>
  );
};

export default AddClient;
